export default __webpack_public_path__ + "static/media/glider3.80f34de8.png";